import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const PasswordValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const rexp =
            /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,20}$/;
        const password = rexp.test(control.value);
        return !password ? { password: { value: control.value } } : null;
    };
};
